import DartsParser from "./gameAssets/gameDartsParser";

export default class CpuOpponent {
   constructor(id, startScore, level, game_id, nextplayertime) {
    this.outsDouble = {
        167:	["T20",	"T19",	"DB"],
        156:	["T20",	"T20",	"D18"],
        153:	["T20",	"T19",	"D18"],
        150:	["T19",	"T19",	"D18"],
        147:	["T19",	"T18",	"D18"],
        144:	["T20",	"T20",	"D12"],
        141:	["T20",	"T19",	"D12"],
        138:	["T20",	"T18",	"D12"],
        135:	["T19",	"T18",	"D12"],
        132:	["T20",	"T16",	"D12"],
        129:	["T19",	"T16",	"D12"],
        126:	["T19",	"T19",	"D6"],
        123:	["T19",	"T16",	"D9"],
        120:	["T20",	"T20",	"0"],
        117:	["T20",	"T19",	"0"],
        114:	["T19",	"T19",	"0"],
        111:	["T19",	"T18",	"0"],
        108:	["T18",	"T18",	"0"],
        105:	["T20",	"T15",	"0"],
        102:	["T20",	"T14",	"0"],
        99:	["T19",	"10",	"D16"],
        96:	["T20",	"D18",	"0"],
        93:	["T19",	"D18",	"0"],
        90:	["T18",	"D18",	"0"],
        87:	["T17",	"D18",	"0"],
        84:	["DB",	"D17",	"0"],
        81:	["T19",	"D12",	"0"],
        78:	["T18",	"D12",	"0"],
        75:	["T12",	"D12",	"0"],
        72:	["T16",	"D12",	"0"],
        69:	["T15",	"D12",	"0"],
        66:	["T14",	"D12",	"0"],
        63:	["T13",	"D12",	"0"],
        60:	["20",	"D20",	"0"],
        57:	["17",	"D20",	"0"],
        54:	["14",	"D20",	"0"],
        51:	["11",	"D20",	"0"],
        48:	["8",	"D20",	"0"],
        170:	["T20",	"T20",	"DB"],
        161:	["T20",	"T17",	"DB"],
        158:	["T20",	"T20",	"D19"],
        155:	["T20",	"T19",	"D19"],
        152:	["T20",	"T20",	"D16"],
        149:	["T20",	"T19",	"D16"],
        146:	["T19",	"T19",	"D16"],
        143:	["T19",	"T18",	"D16"],
        140:	["T20",	"T20",	"D10"],
        137:	["T20",	"T19",	"D10"],
        134:	["T20",	"T14",	"D16"],
        131:	["T19",	"T14",	"D16"],
        128:	["T18",	"T14",	"D16"],
        125:	["DB",	"T17",	"D12"],
        122:	["DB",	"T16",	"D12"],
        119:	["T19",	"T12",	"D13"],
        116:	["T19",	"19",	"D20"],
        113:	["T19",	"16",	"D20"],
        110:	["T20",	"DB",	"0"],
        107:	["T19",	"DB",	"0"],
        104:	["T18",	"DB",	"0"],
        101:	["T17",	"DB",	"0"],
        98:	["DB",	"T16",	"0"],
        95:	["DB",	"T15",	"0"],
        92:	["T20",	"D16",	"0"],
        89:	["T19",	"D16",	"0"],
        86:	["T18",	"D16",	"0"],
        83:	["T17",	"D16",	"0"],
        80:	["T20",	"D10",	"0"],
        77:	["17",	"T20",	"0"],
        74:	["14",	"T20",	"0"],
        71:	["17",	"T18",	"0"],
        68:	["20",	"T16",	"0"],
        65:	["17",	"T16",	"0"],
        62:	["14",	"T16",	"0"],
        59:	["11",	"T16",	"0"],
        56:	["8",	"T16",	"0"],
        53:	["5",	"T16",	"0"],
        50:	["10",	"D20",	"0"],
        47:	["15",	"D16",	"0"],
        164:	["T20",	"T18",	"DB"],
        160:	["T20",	"T20",	"D20"],
        157:	["T20",	"T19",	"D20"],
        154:	["T19",	"T19",	"D20"],
        151:	["T20",	"T17",	"D20"],
        148:	["T20",	"T16",	"D20"],
        145:	["T20",	"B",	"T20"],
        142:	["T20",	"B",	"T19"],
        139:	["T19",	"DB",	"D16"],
        136:	["T20",	"T20",	"D8"],
        133:	["T20",	"T19",	"D8"],
        130:	["T20",	"T20",	"D5"],
        127:	["T20",	"T17",	"D8"],
        124:	["T20",	"T14",	"D11"],
        121:	["T19",	"16",	"T16"],
        118:	["T18",	"16",	"T16"],
        115:	["T19",	"18",	"D20"],
        112:	["T20",	"12",	"D20"],
        109:	["T20",	"9",	"D20"],
        106:	["T20",	"6",	"D20"],
        103:	["B",	"18",	"T20"],
        100:	["T20",	"D20",	"0"],
        97:	["T19",	"D20",	"0"],
        94:	["T18",	"D20",	"0"],
        91:	["T17",	"D20",	"0"],
        88:	["T20",	"D14",	"0"],
        85:	["T15",	"D20",	"0"],
        82:	["DB",	"D16",	"0"],
        79:	["T19",	"D11",	"0"],
        76:	["T20",	"D8",	"0"],
        73:	["T16",	"D12",	"0"],
        70:	["T10",	"D20",	"0"],
        67:	["T17",	"D8",	"0"],
        64:	["T16",	"D8",	"0"],
        61:	["B",	"D18",	"0"],
        58:	["18",	"D20",	"0"],
        55:	["15",	"D20",	"0"],
        52:	["12",	"D20",	"0"],
        49:	["9",	"D20",	"0"],
        46:	["6",	"D20",	"0"],
        45: ["13",   "D16",    "0"],
        44: ["12",   "D16",    "0"],
        43: ["11",   "D16",    "0"],
        42: ["10",   "D15",    "0"],
        41: ["9",   "D16",    "0"],
        40: ["D20",   "0",    "0"],
        39: ["7",   "D16",    "0"],
        38: ["D19",   "0",    "0"],
        37: ["5",   "D16",    "0"],
        36: ["D18",   "0",    "0"],
        35: ["3",   "D16",    "0"],
        34: ["D17",   "0",    "0"],
        33: ["1",   "D16",    "0"],
        32: ["D16",   "0",    "0"],
        31: ["15",   "D8",    "0"],
        30: ["D15",   "0",    "0"],
        29: ["13",   "D8",    "0"],
        28: ["D14",   "0",    "0"],
        27: ["11",   "D8",    "0"],
        26: ["D13",   "0",    "0"],
        25: ["9",   "D8",    "0"],
        24: ["D12",   "0",    "0"],
        23: ["7",   "D8",    "0"],
        22: ["D11",   "0",    "0"],
        21: ["5",   "D8",    "0"],
        20: ["D10",   "0",    "0"],
        19: ["3",   "D8",    "0"],
        18: ["D9",   "0",    "0"],
        17: ["1",   "D8",    "0"],
        16: ["D8",   "0",    "0"],
        15: ["7",   "D4",    "0"],
        14: ["D7",   "0",    "0"],
        13: ["5",   "D4",    "0"],
        12: ["D6",   "0",    "0"],
        11: ["3",   "D4",    "0"],
        10: ["D5",   "0",    "0"],
        9: ["1",   "D4",    "0"],
        8: ["D4",   "0",    "0"],
        7: ["1",   "D3",    "0"],
        6: ["D3",   "0",    "0"],
        5: ["1",   "D2",    "0"],
        4: ["D2",   "0",    "0"],
        3: ["1",   "D1",    "0"],
        2: ["D1",   "0",    "0"]}

        this.board = [
            [ 0,  0],
            [20, 18],
            [15, 17],
            [17, 19],
            [18, 13],
            [12, 20],
            [13, 10],
            [19, 16],
            [16, 11],
            [14, 12],
            [ 6, 15],
            [ 8, 14],
            [ 9,  5],
            [ 4,  6],
            [11,  9],
            [10,  2],
            [ 7,  8],
            [ 2,  3],
            [ 1,  4],
            [ 3,  7],
            [ 5,  1]
        ];

        this.rate_triple = [1,  5 , 10, 13, 15, 17, 20, 25, 30, 40, 50, 70];
        this.rate_double = [10, 15, 20, 23, 25, 27, 30, 35, 40, 50, 60, 70];
        this.rate_single = [20, 30, 40, 55, 60, 70, 80, 85, 90, 90, 90, 95];

        this.id = id;
        this.score = startScore;
        this.level = level;
        this.game_id = game_id;
        this.nextplayertime = parseInt(nextplayertime) * 1000;

        this.roundScore = 0;
   }

   throw() {
        var dart1 = this.throwDartNew();
        if (this.score > 0)
            var dart2 = this.throwDartNew();
        if (this.score > 0)
            var dart3 = this.throwDartNew();

        console.log("cpu is playing round now", this.roundScore, this.score);
        if (this.score < 0) this.roundScore = 0;
        axios.post("/api/sendNumpadInput", {game: this.game_id, input: this.roundScore, saveInput: true});
   }

    playRound(roundStartScore) {
        this.allowSend = true;
        this.score = roundStartScore;
        console.log("cpu is playing round now");
        this.roundScore = 0;
        var thrown = [];
        var dart1 = this.throwDartNew();
        if (this.score > 0)
            var dart2 = this.throwDartNew();
        if (this.score > 0)
            var dart3 = this.throwDartNew();
        setTimeout(() => {
            this.nextPlayer()
        }, this.nextplayertime);
        if (dart1) thrown.push(dart1);
        if (dart2) thrown.push(dart2);
        if (dart3) thrown.push(dart3);
        return thrown;
    }

    addDart(dart) {
        var d = DartsParser.parse(dart)
        //console.log(d.str);
        this.roundScore += d.value;
        this.score -= d.value;
        return d;
    }

    nextPlayer() {
        if (!this.allowSend) return;
        if (this.score < 0 || this.score == 1) this.roundScore = 0;
        axios.post("/api/games/" + this.game_id + "/sendfullscore", {player: this.id, score: this.roundScore})
        this.allowSend = false;
    }

    calculateTarget() {
        if (this.score > 180) {
            return "T20";
        } else {
            //get from outchart
            var outs = this.outsDouble[this.score];
            if (outs && outs.length > 0) {
                return outs[0];
            }
            else {
                return "T20";
            }
        }
    }

    getRandom() {
        return Math.floor(Math.random() * 1000);
    }

    throwDartNew() {
        let targetBase = this.calculateTarget();
        //if cpu should try bull, do a bull throw
        if (targetBase.includes("B")) {
            this.throwAtBull(targetBase);
            return;
        }
        //else normal throw
        var base = 0;
        if (targetBase.includes("T"))  base = parseInt(targetBase.replace("T", ""));
        else if (targetBase.includes("D"))  base = parseInt(targetBase.replace("D", ""));
        else base = parseInt(targetBase)

        var target = 0;
        var segment = "S";
		var arrangeSegment = targetBase.includes("T") ? "T" : targetBase.includes("D") ? "D" : "S";

		var i = base;
		var j = this.getRandom() % 2;
		var single =this.rate_single[this.level - 1];
		do {
			switch (arrangeSegment) {
			case "S":
				if ((this.getRandom() % 100) + 1 <= single) {
					target = i;
					segment = "S";
				} else if ((this.getRandom() % 100) + 1 > single) {
					if ((this.getRandom() % 100) + 1 <=this.rate_triple[this.level - 1]) {
						target = i;
						segment = "T";
					} else if ((this.getRandom() % 100) + 1 <=this.rate_double[this.level - 1]) {
						target = i;
						segment = "D";
					} else {
						i = this.board[i][j];
					}
				} else {
					i = this.board[i][j];
				}
				break;
			case "D":
				if ((this.getRandom() % 100) + 1 <=this.rate_double[this.level - 1]) {
					target = i;
					segment = "D";
				} else if ((this.getRandom() % 100) + 1 <= single) {
					if ((this.getRandom() % 100) + 1 <= 50) {
						target = i;
						segment = "S";
					} else {
                        target = -1;
                        segment = "S";
					}
				} else {
					i = this.board[i][j];
				}
				break;
			case "T":
				if ((this.getRandom() % 100) + 1 <=this.rate_triple[this.level - 1]) {
					target = i;
					segment = "T";
				} else if ((this.getRandom() % 100) + 1 <= single) {
					target = i;
					segment = "S";
				} else {
					i = this.board[i][j];
				}
				break;
			}
			single += single * 0.3;
        } while (target === 0);
        if (target == -1) target = 0; //overwrite -1 for breaking in double
        if (segment == "S") segment = ""; //return S to nothing

        //console.log("AIMED AT "+ targetBase, segment+target, this.level);

        return this.addDart(segment+target);
    }

    throwAtBull(targetBase) {

		var target = 25;
		var segment = "S";
		if ((this.getRandom()  % 100) + 1 > this.rate_double[this.level - 1]) {
			target = (this.getRandom()  % 20) + 1;
		}
		if (target === 25) {
			switch (targetBase.includes("D") ? "D" : "S") {
			case "S":
				if ((this.getRandom()  % 100) + 1 <= this.rate_double[this.level - 1]) {
					segment = "S";
				}
				break;
			case "D":
				if ((this.getRandom()  % 100) + 1 <= this.rate_triple[this.level - 1]) {
					segment = "D";
				}
				break;
			}
        }
        if (segment == "S") segment = "";
		this.addDart(segment+target);
	};
}
